import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';

export default function SupplierRelationship() {
  const [retail, setRetail] = useState();
  const [inpremises, setInpremises] = useState([]);
  const [preferred, setPreferred] = useState([]);
  const { id } = useParams();

  const getRelation = async () => {
    let res = await APIServiceAPIService.get(ANG_APIS.GET_SUPPLIER_RELATIONSHIP);
    if (res.status == 200) setRetail(res.data);

    let res1 = await APIService.get(`${ANG_APIS.GET_SUPPLIER_RELATIONSHIP}${id}&type=PREFERRED`);
    if (res1.status == 200) setPreferred(res1.data);

    let res2 = await APIService.get(`${ANG_APIS.GET_SUPPLIER_RELATIONSHIP}${id}&type=INPREMISES`);
    if (res2.status == 200) setInpremises(res2.data);
  };

  useEffect(() => {
    getRelation();
  }, []);

  return (
    <div>
      <div className="col-md-12" style={{ margin: '10px' }}>
        <label className="col-md-4">Retailers available in premises : </label>
        <div className="col-md-6" ng-repeat="retail in retailShopInsidePremises">
          {retail?.name}
        </div>
        <div className="col-md-6" ng-if="retailShopInsidePremises.length == 0">
          No retailer in premises available
        </div>
      </div>
      <div className="col-md-12" style={{ margin: '10px' }}>
        <label className="col-md-4">Select retailer in premises : </label>
        <div
          className="col-md-6"
          ng-dropdown-multiselect=""
          options="nearbyRetailShopsExceptInsidePremises"
          selected-model="retailShopInsidePremisesSelected"
          extra-settings="retailShopsInsidePremisesSettings"
          translation-texts="selected_baselines_customTexts"
        ></div>
      </div>
      <div className="col-md-12" style={{ margin: '10px' }}>
        <label className="col-md-4">Preferred Retailers : </label>
        <div className="col-md-6" ng-repeat="retail in preferredRetailers">
          {retail?.name}
        </div>
        <div className="col-md-6" ng-if="preferredRetailers.length == 0">
          No preferred retailers available
        </div>
      </div>
      <div className="col-md-12" style={{ margin: '10px' }}>
        <label className="col-md-4">Select preferred retailers : </label>
        <div
          className="col-md-6"
          ng-dropdown-multiselect=""
          options="nearbyRetailShopsExceptPreferredRetailers"
          selected-model="nearbyRetailShopsSelected"
          extra-settings="nearbyRetailShopsSettings"
          translation-texts="selected_baselines_customTexts"
        ></div>
      </div>
      <input
        style={{ marginLeft: '40px' }}
        type="button"
        className="smallBtn"
        ng-click="onSubmit()"
        value="Save and Continue"
      />
    </div>
  );
}
